/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import ApplyLetterModalPresenter from './ApplyLetterModalPresenter';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: VoidFunction;
}

const ApplyLetterModalController = ({
  isModalOpen,
  closeModal,
}: ModalInterface) => {

  return (
    <ApplyLetterModalPresenter
      isModalOpen={isModalOpen}
      closeModal={closeModal}
    />
  );
};

export default ApplyLetterModalController;
